/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaQdPublishingRequest model module.
 * @module model/AqaQdPublishingRequest
 * @version v0
 */
export default class AqaQdPublishingRequest {
  /**
   * Constructs a new <code>AqaQdPublishingRequest</code>.
   * @alias module:model/AqaQdPublishingRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaQdPublishingRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaQdPublishingRequest} obj Optional instance to populate.
   * @return {module:model/AqaQdPublishingRequest} The populated <code>AqaQdPublishingRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaQdPublishingRequest();
      if (data.hasOwnProperty('scope'))
        obj.scope = ApiClient.convertToType(data['scope'], 'String');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('version'))
        obj.version = ApiClient.convertToType(data['version'], 'Number');
      if (data.hasOwnProperty('accountsToShareWith'))
        obj.accountsToShareWith = ApiClient.convertToType(data['accountsToShareWith'], ['String']);
    }
    return obj;
  }
}

/**
 * Allowed values for the <code>scope</code> property.
 * @enum {String}
 * @readonly
 */
AqaQdPublishingRequest.ScopeEnum = {
  /**
   * value: "PRIVATE"
   * @const
   */
  PRIVATE: "PRIVATE",

  /**
   * value: "PROTECTED"
   * @const
   */
  PROTECTED: "PROTECTED",

  /**
   * value: "PUBLIC"
   * @const
   */
  PUBLIC: "PUBLIC"
};
/**
 * @member {module:model/AqaQdPublishingRequest.ScopeEnum} scope
 */
AqaQdPublishingRequest.prototype.scope = undefined;

/**
 * @member {String} title
 */
AqaQdPublishingRequest.prototype.title = undefined;

/**
 * @member {String} description
 */
AqaQdPublishingRequest.prototype.description = undefined;

/**
 * @member {Number} version
 */
AqaQdPublishingRequest.prototype.version = undefined;

/**
 * @member {Array.<String>} accountsToShareWith
 */
AqaQdPublishingRequest.prototype.accountsToShareWith = undefined;

